import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreateVendorModel,
  CreateVendorResponseModel,
  VendorConfirmationRequest,
  VendorConfirmationResponse,
  VendorDashboardItem,
} from '@app/models';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  constructor(private http: HttpClient) {}

  createVendor(vendor: CreateVendorModel): Observable<CreateVendorResponseModel> {
    return this.http.post<CreateVendorResponseModel>(`${environment.apiUrl}/api/pub/Vendor/CreateVendor`, vendor);
  }

  resendVendorConfirmation(vendorToken: string): Observable<string> {
    return this.http.post<string>(`${environment.apiUrl}/api/pub/Vendor/ResendConfirmEmail`, vendorToken);
  }

  confirmVendorAccount(vendorToken: string, key: string): Observable<VendorConfirmationResponse> {
    const model: VendorConfirmationRequest = { vendorToken, key };
    return this.http.post<VendorConfirmationResponse>(
      `${environment.apiUrl}/api/pub/Vendor/ConfirmVendorAccount`,
      model
    );
  }

  getVendorDashboard(): Observable<VendorDashboardItem[]> {
    return this.http.get<VendorDashboardItem[]>(`${environment.apiUrl}/api/vendor/Base/GetVendorDashboard`);
  }
}
